import { SVGProps } from "react"

const CaseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 5.8999C1 5.34762 1.44772 4.8999 2 4.8999H14C14.5523 4.8999 15 5.34762 15 5.8999V7.75585C15 8.19746 14.7103 8.58678 14.2873 8.71368L8.28735 10.5137C8.09991 10.5699 7.90009 10.5699 7.71265 10.5137L1.71265 8.71368C1.28967 8.58678 1 8.19746 1 7.75585V5.8999Z"
        stroke="black"
      />
      <path
        d="M1 5.8999C1 5.34762 1.44772 4.8999 2 4.8999H14C14.5523 4.8999 15 5.34762 15 5.8999V7.75585C15 8.19746 14.7103 8.58678 14.2873 8.71368L8.28735 10.5137C8.09991 10.5699 7.90009 10.5699 7.71265 10.5137L1.71265 8.71368C1.28967 8.58678 1 8.19746 1 7.75585V5.8999Z"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M1 5.8999C1 5.34762 1.44772 4.8999 2 4.8999H14C14.5523 4.8999 15 5.34762 15 5.8999V7.75585C15 8.19746 14.7103 8.58678 14.2873 8.71368L8.28735 10.5137C8.09991 10.5699 7.90009 10.5699 7.71265 10.5137L1.71265 8.71368C1.28967 8.58678 1 8.19746 1 7.75585V5.8999Z"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M1 5.8999C1 5.34762 1.44772 4.8999 2 4.8999H14C14.5523 4.8999 15 5.34762 15 5.8999V7.75585C15 8.19746 14.7103 8.58678 14.2873 8.71368L8.28735 10.5137C8.09991 10.5699 7.90009 10.5699 7.71265 10.5137L1.71265 8.71368C1.28967 8.58678 1 8.19746 1 7.75585V5.8999Z"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path d="M8 8.3L8 7.5" stroke="black" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M8 8.3L8 7.5"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 8.3L8 7.5"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 8.3L8 7.5"
        stroke="black"
        stroke-opacity="0.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.58301 8.5L1.58301 14.1C1.58301 14.6522 2.03072 15.1 2.58301 15.1H13.4163C13.9686 15.1 14.4163 14.6522 14.4163 14.1V8.5"
        stroke="black"
      />
      <path
        d="M1.58301 8.5L1.58301 14.1C1.58301 14.6522 2.03072 15.1 2.58301 15.1H13.4163C13.9686 15.1 14.4163 14.6522 14.4163 14.1V8.5"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M1.58301 8.5L1.58301 14.1C1.58301 14.6522 2.03072 15.1 2.58301 15.1H13.4163C13.9686 15.1 14.4163 14.6522 14.4163 14.1V8.5"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M1.58301 8.5L1.58301 14.1C1.58301 14.6522 2.03072 15.1 2.58301 15.1H13.4163C13.9686 15.1 14.4163 14.6522 14.4163 14.1V8.5"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M10.3337 4.89999V4.5C10.3337 3.39543 9.43823 2.5 8.33366 2.5H7.66699C6.56242 2.5 5.66699 3.39543 5.66699 4.5L5.66699 4.89999"
        stroke="black"
      />
      <path
        d="M10.3337 4.89999V4.5C10.3337 3.39543 9.43823 2.5 8.33366 2.5H7.66699C6.56242 2.5 5.66699 3.39543 5.66699 4.5L5.66699 4.89999"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M10.3337 4.89999V4.5C10.3337 3.39543 9.43823 2.5 8.33366 2.5H7.66699C6.56242 2.5 5.66699 3.39543 5.66699 4.5L5.66699 4.89999"
        stroke="black"
        stroke-opacity="0.2"
      />
      <path
        d="M10.3337 4.89999V4.5C10.3337 3.39543 9.43823 2.5 8.33366 2.5H7.66699C6.56242 2.5 5.66699 3.39543 5.66699 4.5L5.66699 4.89999"
        stroke="black"
        stroke-opacity="0.2"
      />
    </svg>
  )
}

export default CaseIcon
